import { jsx as r, jsxs as n } from "react/jsx-runtime";
import { Image as c } from "../Image/index.js";
import { Icon as l } from "../Icon/index.js";
import { useTranslation as d } from "../../hooks/useTranslation/index.js";
import { ProductLink as p, Container as f, Content as s, ImageContainer as h, Divider as u, ProductName as C, SeeProduct as g } from "./style.js";
import { ChevronRight as I } from "@pelando/fontawesome/icons";
function b({
  title: o,
  productImage: e,
  url: i,
  errorImage: m,
  ...t
}) {
  const { t: a } = d("common");
  return /* @__PURE__ */ r(p, { url: i, rel: "nofollow noreferrer noopener", children: /* @__PURE__ */ n(f, { ...t, children: [
    /* @__PURE__ */ n(s, { children: [
      /* @__PURE__ */ r(h, { children: /* @__PURE__ */ r(
        c,
        {
          src: e,
          errorImage: m,
          alt: `${a("small-product-card-image-aria-label")} ${o}`
        }
      ) }),
      /* @__PURE__ */ r(u, {}),
      /* @__PURE__ */ r(C, { children: o })
    ] }),
    /* @__PURE__ */ r(g, { children: /* @__PURE__ */ r(l, { icon: I }) })
  ] }) });
}
export {
  b as SmallProductCard
};
